import {Controller, useWatch} from "react-hook-form";
import {InputField, SelectField} from "~/components/Forms";
import {useGetProvincesQuery, useGetWardsQuery} from "~/reduxs/api/locationApiSlice";

/**
 * Cụm field địa chỉ dùng chung: Tỉnh/Thành (city) → Phường/Xã (ward, phụ thuộc tỉnh)
 * + Địa chỉ chi tiết (address). Là 1 control form (như InputField/SelectField).
 *
 * Props: control, errors, setValue (từ useForm) — để reset ward khi đổi tỉnh.
 */
function AddressFields({control, errors, setValue}) {

	const province = useWatch({control, name: 'city'});

	const {data: provinces = []} = useGetProvincesQuery();
	const {data: wards = []}     = useGetWardsQuery(province, {skip: !province});

	return (
		<>
			<div className="mform-grid-2">
				<Controller control={control} name="city" render={({field}) => (
					<SelectField
						label="Tỉnh / Thành phố"
						placeholder="Chọn tỉnh/thành"
						options={provinces}
						errors={errors}
						allowClear
						{...field}
						onChange={(val) => { field.onChange(val ?? null); setValue('ward', null); }}
					/>
				)} />
				<Controller control={control} name="ward" render={({field}) => (
					<SelectField
						label="Phường / Xã"
						placeholder={province ? 'Chọn phường/xã' : 'Chọn tỉnh trước'}
						options={wards}
						errors={errors}
						allowClear
						disabled={!province}
						{...field}
						onChange={(val) => field.onChange(val ?? null)}
					/>
				)} />
			</div>

			<Controller control={control} name="address" render={({field}) => (
				<InputField label="Địa chỉ chi tiết" placeholder="Số nhà, tên đường..." errors={errors} {...field} />
			)} />
		</>
	);
}

export default AddressFields;
